module.exports = __webpack_public_path__ + "img/article3.98f62ba1.jpg";